<template>
  <div class="toggle" @click="active = !active">
    <slot name="on" v-if="active"></slot>
    <slot name="off" v-if="!active"></slot>
  </div>
</template>

<script>
  export default {
    name: 'Toggle',
    data () {
      return {
        active: false
      }
    },
  }
</script>

<style scoped>

</style>
